import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Col, Row, Form, Button } from "react-bootstrap";
import { formatInputDate } from "../../utils/Time";
import { calculator } from "../../utils/Calculator";
import {
  initializeSetOption,
  initializeSetOptionMulti
} from "../../utils/InitializeSetDefault";
import { filteredItemInArray, findItemInArray } from "../../utils/ManageArray";
import { useAuth } from "../../context/AuthContext";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import { autoDisplayValue } from "../../commons/FormatValue";

import {
  deleteServiceRequest,
  getServiceRequest
} from "../../commons/ServiceRequest";

import {
  FloatingControlComponent,
  SearchSelectComponent
} from "../FormComponent";
import TableForm from "../TableForm";
import SearchFilter from "../SearchFilter";
import ConfirmModal from "../ConfirmModal";
import CardDisplayComponent from "../CardDisplayComponent";
import ItemsService from "../../services/item.service";
import JobTypeService from "../../services/jobtype.service";
import SeqPMJobsService from "../../services/seqpmjob.service";
import EmployeesService from "../../services/employee.service";
import WarehouseService from "../../services/warehouse.service";
import ChildBomsService from "../../services/childboms.service";
import BillOfReqHdService from "../../services/billofreqhd.service";
import BillOfReqDtService from "../../services/billofreqdt.service";
import SeqOthersJobsService from "../../services/seqothersjob.service";
import SeqRepairJobsService from "../../services/seqrepairjob.service";
import SeqInstallJobsService from "../../services/seqinstalljob.service";
import InformInstallItemBomsService from "../../services/informinstallitembom.service";

const CreateRequisitionForm = ({ onSubmitCallback }) => {
  const { user } = useAuth();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading(false);
  const [showModal, setShowModal] = useState({ save: false, del: false });
  const [findDel, setFindDel] = useState({ Id: 0, newData: [] });
  const [searchValue, setSearchValue] = useState(null);
  const [validated, setValidated] = useState(false);
  const [checkType, setCheckType] = useState(true);
  const [CheckSeq, setCheckSeq] = useState("");
  const [JopTypeId, setJopTypeId] = useState("");
  const [Seq, setSeq] = useState([]);
  const [Items, setItems] = useState([]);
  const [Req_By, setReq_By] = useState([]);
  const [Parent, setParent] = useState([]);
  const [JobType, setJobType] = useState([]);
  const [ChildBoms, setChildBoms] = useState([]);
  const [Warehouse, setWarehouse] = useState([]);
  const [Department, setDepartment] = useState([]);
  const [Approved_By, setApproved_By] = useState([]);
  const [ParentSearch, setParentSearch] = useState([]);
  const isEditMode = state?.name === "edit";

  const searchType = [
    {
      name: "Job_Type_Code",
      labelName: "Job_Type_Name",
      filterBy: ["Job_Type_Name"],
      noneAsync: true,
      label: "ประเภทงาน",
      size: null
    }
  ];

  const currentDate = new Date().toISOString();
  const defaultData = {
    BillOfReqHd: {
      Job_Type_Id: null,
      Seq_Pm_Id: null,
      Seq_Inst_Id: null,
      Seq_Oth_Id: null,
      Seq_Serv_Id: null,
      Bill_Doc_No: null,
      Bill_Doc_Date: currentDate,
      Ref_Seq_No: null,
      Ref_Do_No: null,
      Project_No: null,
      Call_No: null,
      Job_Type_Name: "",
      Job_Type_Sub_Name: "",
      Req_By_Id: "",
      Req_Dept: "",
      Approved_By_Id: "",
      Remark: "",
      Bill_of_Req_Status: "",
      Prefix_Doc: null,
      Com_Code: user.Com_Code
    },
    BillOfReqDt: {
      Bill_Of_Hd_Id: 0,
      Item_Id: 0,
      Item_Child_Id: 0,
      Wh_Code: "",
      Wh_Bal_Qty: 0,
      Req_Qty: 0,
      Iss_Qty: 0,
      Bal_Iss_Qty: 0,
      Unit_Uom: "",
      Use_Status: "N",
      Com_Code: user.Com_Code
    }
  };
  const [data, setData] = useState({
    BillOfReqHd: defaultData.BillOfReqHd,
    BillOfReqDt: [defaultData.BillOfReqDt]
  });

  const inputField = {
    Input: [
      {
        name: "Bill_Doc_No",
        label: "เลขที่ใบขอเบิก",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Ref_Seq_No",
        label: "เลขที่ใบสั่งงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 2
      },
      {
        name: "Job_Type_Name",
        label: "ประเภทงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: checkType ? "1_5" : null
      },
      {
        name: "Job_Type_Sub_Name",
        label: "ประเภทงานย่อย",
        classNames: { col: "mb-3", label: "mb-1" },
        size: checkType ? null : 2
      },
      {
        name: "Pm_Of_Work",
        label: "PM/ครั้งที่",
        classNames: { col: "mb-3", label: "mb-1" },
        size: checkType ? null : 2,
        hidden: !checkType
      },
      {
        name: "Bill_Doc_Date",
        label: "วันที่ออกใบเบิก",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "date",
        size: "1_5",
        format: (value) => formatInputDate(value, "Local")?.date
      },
      {
        name: "Bill_Doc_Date",
        label: "",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "time",
        size: "1_5",
        format: (value) => formatInputDate(value, "Local")?.time
      },
      {
        name: "Cus_Code",
        label: "รหัสลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Cus_Name",
        label: "ชื่อลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "Ref_Do_No",
        label: "Ref.เลขที่ใบเบิก (DO)",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "BP_Code",
        label: "รหัสสาขา",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "BP_NumBranch",
        label: "เลขที่สาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "BP_Name",
        label: "ชื่อสาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "4_5"
      },
      {
        name: "Service_Call",
        label: "Call No.",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "Project_No",
        label: "เลขโครงการ",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      { name: "Remark", label: "หมายเหตุ", size: null, disabled: false },
      {
        name: "Prefix_Doc",
        label: "Prefix Doc",
        size: "1_5",
        type: "select",
        disabled: isEditMode ? true : false,
        noneAsync: true,
        options: [
          { value: "FDO", label: "FDO" },
          { value: "FDR", label: "FDR" }
        ]
      },
      {
        name: "Bill_of_Req_Status",
        label: "สถานะใบขอเบิก",
        size: "1_5",
        type: "select",
        noneAsync: true,
        minKeywordLength: 1,
        options: [
          { value: "OPEN", label: "OPEN" },
          { value: "CANCEL", label: "CANCEL" },
          { value: "CLOSED", label: "CLOSED" }
        ]
      }
    ],
    Input_2: [
      {
        name: "Req_By_Id",
        label: "ผู้ขอเบิก",
        type: "select",
        required: true,
        minKeywordLength: 1,
        filterBy: ["Employee_Name", "Employee_Surname"],
        options: initializeSetOptionMulti({
          key: "Id",
          label: ["Employee_Name", "Employee_Surname"],
          operator: " ",
          dataset: Req_By
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: EmployeesService.getAllEmployees(query),
            callback: ({ items }) => setReq_By(items)
          })
      },
      {
        name: "Req_Dept",
        label: "แผนก",
        type: "select",
        required: true,
        minKeywordLength: 1,
        filterBy: ["Employee_Department"],
        options: initializeSetOption({
          key: "Employee_Department",
          dataset: Department
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: EmployeesService.getAllEmployees(query),
            callback: ({ items }) => setDepartment(items)
          })
      },
      {
        name: "Approved_By_Id",
        label: "ผู้อนุมัติเบิก",
        type: "select",
        required: true,
        minKeywordLength: 1,
        filterBy: ["Employee_Name", "Employee_Surname"],
        options: initializeSetOptionMulti({
          key: "Id",
          label: ["Employee_Name", "Employee_Surname"],
          operator: " ",
          dataset: Approved_By
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: EmployeesService.getAllEmployees(query),
            callback: ({ items }) => setApproved_By(items)
          })
      }
    ],
    BillOfReqDt: [
      {
        name: "Item_Id",
        label: "รหัสอุปกรณ์/อะไหล่",
        type: "select",
        size: 2,
        noneRequired: true,
        filterBy: ["Item_Code"],
        options: initializeSetOption({
          key: "Id",
          label: "Item_Code",
          dataset: Items
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: ItemsService.getAllItems(query),
            callback: ({ items }) => setItems(items)
          })
      },
      {
        name: "Item_Name_TH",
        label: "รายละเอียดอุปกรณ์/อะไหล่",
        type: "text",
        size: 2,
        findValue: { data: Items, key: "Id", value: "Item_Id" },
        readOnly: true,
        noneRequired: true
      },
      {
        name: "Wh_Code",
        label: "คลัง",
        type: "select",
        size: "1_5",
        noneAsync: true,
        options: initializeSetOption({ key: "WH_Code", dataset: Warehouse })
      },
      { name: "Wh_Bal_Qty", label: "ยอดคงคลัง", readOnly: true },
      { name: "Item_Install_Qty", label: "จำนวนที่ต้องการ", readOnly: true },
      { name: "Iss_Qty", label: "จำนวนเบิก" },
      { name: "Bal_Iss_Qty", label: "จำนวนที่ค้าง", readOnly: true },
      {
        name: "Unit",
        label: "หน่วย",
        type: "text",
        findValue: { data: Items, key: "Id", value: "Item_Id" },
        readOnly: true
      },
      {
        name: "Use_Status",
        label: "Use.",
        type: "select",
        size: "1_5",
        noneAsync: true,
        options: [
          { value: "Y", label: "Y" },
          { value: "N", label: "N" }
        ]
      }
    ],
    Item_parent: [
      {
        name: "Item_parent",
        label: "รหัสสินค้า",
        noneRequired: true,
        disabled: false,
        size: 3
      },
      {
        name: "Item_Name_TH",
        label: "รายละเอียดสินค้า",
        disabled: false,
        size: 6
      }
    ]
  };

  const InputSearch = (field, rowClass) => {
    return (
      <Row className={rowClass}>
        {field?.map(
          (
            {
              name,
              label,
              size,
              type,
              format,
              classNames,
              disabled,
              minKeywordLength,
              options,
              required,
              queryService,
              filterBy,
              hidden,
              noneAsync
            },
            idx
          ) => {
            const rowField = data?.BillOfReqHd;
            const result =
              (format && format(rowField?.[name])) || rowField?.[name] || "";

            return (
              !hidden && (
                <Col
                  key={idx}
                  sm={size === null ? null : size || 3}
                  className={`${classNames?.col}`}
                >
                  {type !== "select" ? (
                    <FloatingControlComponent
                      type={type}
                      name={name}
                      label={label}
                      required={required}
                      className={classNames}
                      disabled={disabled !== false}
                      onChange={(e) => handleChange(name, e?.target?.value)}
                      value={result}
                    />
                  ) : (
                    <SearchSelectComponent
                      floatingClass={classNames?.label}
                      labelField={label}
                      placeholder="โปรดเลือก"
                      disabled={disabled}
                      noneAsync={noneAsync}
                      minKeywordLength={minKeywordLength}
                      options={options || []}
                      queryService={queryService}
                      isInvalid={required && rowField === ""}
                      filterBy={filterBy}
                      onChange={(change) => handleChange(name, change?.value)}
                      value={result}
                    />
                  )}
                </Col>
              )
            );
          }
        )}
      </Row>
    );
  };

  const getEmployeeData = (field) => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: EmployeesService.getAllEmployees(),
      callback: ({ items }) =>
        field === "Approved_By_Id"
          ? setApproved_By(items)
          : field === "Req_By_Id"
            ? setReq_By(items)
            : setDepartment(items)
    });
  };

  const handleChange = (name, value) => {
    let findEmployee;
    if (name === "Req_By_Id") {
      findEmployee = findItemInArray(Req_By, "Id", value);
      getEmployeeData(name);
    } else if (name === "Approved_By_Id") {
      findEmployee = findItemInArray(Approved_By, "Id", value);
      getEmployeeData(name);
    } else if (name === "Req_Dept") {
      findEmployee = findItemInArray(Department, "Employee_Department", value);
      getEmployeeData(name);
    }

    setData((prev) => ({
      ...prev,
      BillOfReqHd: { ...prev.BillOfReqHd, [name]: value }
    }));
  };

  // const handleSearchFilterCombind = (search) => {
  //   const shouldClearState = search.some(({ value }) => value);
  //   const findedType = findItemInArray(search, "name", "Job_Type_Name")?.value;
  //   const findedNo = findItemInArray(search, "name", "Seq_Oth_No")?.value;
  //   const Seq = findItemBySearch(SeqOthers, search);

  //   const ItemOther = Seq?.InformOtherJob?.ItemOther;
  //   const newSearch = filteredCreateNewKey({
  //     data: BillOfReqHd,
  //     search,
  //     newName: "Bill_Of_Hd_Id",
  //     newValue: "Id"
  //   });
  //   const findedHd = findItemBySearch(BillOfReqHd, search);
  //   const filteredData = filteredItemBySearch(BillOfReqDt, newSearch);

  //   const ReqHd = isEditMode
  //     ? findItemInArray(BillOfReqHd, "Id", findedNo)
  //     : {
  //         ...Seq,
  //         Bill_Doc_Date: currentDate,
  //         Bill_of_Req_Status: "OPEN",
  //         Prefix_Doc: "FD",
  //         Req_By: "",
  //         Req_Dept: "",
  //         Approved_By: "",
  //         Remark: ""
  //       };
  //   const ReqDt = isEditMode
  //     ? filteredItemInArray(BillOfReqDt, "Bill_Of_Hd_Id", findedNo)
  //     : ItemOther?.length > 0
  //     ? ItemOther.map(({ Item_Id, Item_Install_Qty, Uom_Unit }) => ({
  //         ...defaultData.BillOfReqDt,
  //         Item_Id,
  //         Req_Qty: Item_Install_Qty,
  //         Unit_Uom: Uom_Unit
  //       }))
  //     : [defaultData.BillOfReqDt];

  //   setSearchValue(search);
  //   (isEditMode ? filteredData : ItemOther)?.forEach(({ Item }) =>
  //     setItems((prev) => (shouldClearState ? [...prev, Item] : []))
  //   );

  //   if (isEditMode) {
  //     getEmployeeData("Approved_By", findedHd?.Approved_By?.split(" ")?.[0]);
  //     getEmployeeData("Req_By", findedHd?.Req_By?.split(" ")?.[0]);
  //     getEmployeeData("Req_Dept", findedHd?.Req_Dept);

  //     setCheckType(
  //       shouldClearState
  //         ? ["PM", "ติดตั้ง", "แจ้งซ่อม"].includes(findedType)
  //         : true
  //     );
  //     setData((prev) => ({
  //       ...prev,
  //       BillOfReqHd: shouldClearState ? findedHd : defaultData.BillOfReqHd,
  //       BillOfReqDt: shouldClearState
  //         ? filteredData?.length > 0
  //           ? filteredData
  //           : [defaultData.BillOfReqDt]
  //         : [defaultData.BillOfReqDt]
  //     }));
  //   } else {
  //     setData((prev) => ({
  //       ...prev,
  //       BillOfReqHd: findedNo ? ReqHd : defaultData.BillOfReqHd,
  //       BillOfReqDt: findedNo ? ReqDt : [defaultData.BillOfReqDt]
  //     }));
  //   }
  // };

  const handleSearchType = (search) => {
    const searchValue = search?.[0]?.value;
    if (searchValue) {
      const serviceMap = {
        "001": SeqInstallJobsService.getAllSeqInstallJob,
        "002": SeqRepairJobsService.getAllSeqRepairJob,
        "005": SeqPMJobsService.getAllSeqPMJobs
      };
      const defaultService = SeqOthersJobsService.getAllSeqOthersJobs;
      const serviceRequest = serviceMap[searchValue] || defaultService;

      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: serviceRequest(),
        callback: (items) => {
          // เพิ่ม property Seq_Id เข้าไปในทุกๆ ออบเจ็กต์ของ items

          const modifiedItems = items.map((item) => ({
            ...item,
            JobType: searchValue,
            Seq_Id: item?.id || item?.Id,
            Seq_No:
              item?.seq_install_no ||
              item?.seq_repair_no ||
              item?.seq_Pm_no ||
              item?.Seq_Oth_No
          }));

          // อัปเดตค่าของ seq ด้วยข้อมูลที่ถูกแก้ไขแล้ว
          setSeq(
            modifiedItems?.[0]?.InformOtherJob?.JobType?.Job_Type_Code
              ? filteredItemInArray(
                modifiedItems,
                "InformOtherJob.JobType.Job_Type_Code",
                searchValue
              )
              : modifiedItems
          );

          if(state?.job_type_id && !search?.[0]?.label) {
            setCheckSeq(
              modifiedItems.find(el => el.Seq_No == state?.seq_no)?.id
            )
          }
        }
      });
      setJopTypeId(searchValue);
    }
  };

  const handleSearchSeq = (search) => {
    setCheckSeq(search?.value);
    const newAdditionalValue = filteredItemInArray(Seq, "id", search?.value)[0];
    const newOther = filteredItemInArray(Seq, "Id", search?.value)[0];

    switch (JopTypeId) {
      case "001":
        {
          setData((prevData) => ({
            ...prevData,
            BillOfReqHd: {
              ...prevData.BillOfReqHd,
              ...{
                Job_Type_Id: newAdditionalValue?.job_type_id,
                Seq_Pm_Id: null,
                Seq_Inst_Id: newAdditionalValue?.Seq_Id,
                Seq_Oth_Id: null,
                Seq_Serv_Id: null,
                Bill_Doc_No: null,
                Bill_Doc_Date: currentDate,
                Ref_Seq_No: newAdditionalValue?.Seq_No,
                Job_Type_Name:
                  newAdditionalValue?.InformInstallJobs?.JobType?.Job_Type_Name,
                Job_Type_Sub_Name:
                  newAdditionalValue?.InformInstallJobs?.JobTypeSub
                    ?.Job_Type_Sub_Name,
                Cus_Code:
                  newAdditionalValue?.InformInstallJobs?.Customer?.Cus_Code,
                Cus_Name:
                  newAdditionalValue?.InformInstallJobs?.Customer?.Cus_Name,
                BP_Code:
                  newAdditionalValue?.InformInstallJobs?.BPCustomer?.Cus_Code,
                BP_NumBranch:
                  newAdditionalValue?.InformInstallJobs?.BPCustomer
                    ?.Cus_NumBranch,
                BP_Name:
                  newAdditionalValue?.InformInstallJobs?.BPCustomer?.Cus_Name,
                Service_Call:
                  newAdditionalValue?.InformInstallJobs?.Service_Call,
                Project_No:
                  newAdditionalValue?.InformInstallJobs?.CustContract
                    ?.Project_No
              }
            }
          }));
          const checkAsset =
            newAdditionalValue?.InformInstallJobs?.InformInstallItem.map(
              (item) => item.Asset_Code
            );

          if (checkAsset) {
            setParent(
              newAdditionalValue?.InformInstallJobs?.InformInstallItem.map(
                (item) => ({
                  Item_Code: item.AssetItem.Asset_Code,
                  Item_Name_TH: item.AssetItem.Asset_Name,
                  Id: item.AssetItem.Id
                })
              )
            );
          } else {
            setParent(
              newAdditionalValue?.InformInstallJobs?.InformInstallItem.map(
                (item) => item.Item
              )
            );
          }

          //
        }

        break;
      case "002":
        {
          setData((prevData) => ({
            ...prevData,
            BillOfReqHd: {
              ...prevData.BillOfReqHd,
              ...{
                Job_Type_Id: newAdditionalValue?.job_type_id,
                Seq_Pm_Id: null,
                Seq_Inst_Id: null,
                Seq_Oth_Id: null,
                Seq_Serv_Id: newAdditionalValue?.Seq_Id,
                Bill_Doc_No: null,
                Bill_Doc_Date: currentDate,
                Ref_Seq_No: newAdditionalValue?.Seq_No,
                Job_Type_Name:
                  newAdditionalValue?.inform_repair_items?.job_type_items
                    ?.Job_Type_Name,
                Job_Type_Sub_Name:
                  newAdditionalValue?.inform_repair_items?.job_type_sub_items
                    ?.Job_Type_Sub_Name,
                Cus_Code:
                  newAdditionalValue?.inform_repair_items
                    ?.concern_customer_items?.Cus_Code,
                Cus_Name:
                  newAdditionalValue?.inform_repair_items
                    ?.concern_customer_items?.Cus_Name,
                // BP_Code: inform_repair_items?.BPCustomer?.Cus_Code,
                // BP_NumBranch: inform_repair_items?.BPCustomer?.Cus_NumBranch,
                // BP_Name: inform_repair_items?.BPCustomer?.Cus_Name,
                Service_Call:
                  newAdditionalValue?.inform_repair_items?.service_call,
                Project_No:
                  newAdditionalValue?.inform_repair_items?.CustContract
                    ?.project_no
              }
            }
          }));
          setParent(
            newAdditionalValue?.inform_repair_items?.repair_job_items.map(
              (item) => item.repair_items
            )
          );
        }
        break;
      case "005":
        {
          // setData((prevData) => ({
          //   ...prevData,
          //   BillOfReqHd: newAdditionalValue.map(
          //     ({
          //       job_type_id,
          //       Seq_Id,
          //       Seq_No,
          //       inform_repair_items,
          //       ...item
          //     }) => ({
          //       ...item,
          //       Job_Type_Id: job_type_id,
          //       Seq_Pm_Id: null,
          //       Seq_Inst_Id: null,
          //       Seq_Oth_Id: null,
          //       Seq_Serv_Id: Seq_Id,
          //       Bill_Doc_No: null,
          //       Bill_Doc_Date: currentDate,
          //       Ref_Seq_No: Seq_No,
          //       Job_Type_Name:
          //         inform_repair_items?.job_type_items?.Job_Type_Name,
          //       Job_Type_Sub_Name:
          //         inform_repair_items?.job_type_sub_items?.Job_Type_Sub_Name,
          //       Cus_Code: inform_repair_items?.concern_customer_items?.Cus_Code,
          //       Cus_Name: inform_repair_items?.concern_customer_items?.Cus_Name,
          //       // BP_Code: inform_repair_items?.BPCustomer?.Cus_Code,
          //       // BP_NumBranch: inform_repair_items?.BPCustomer?.Cus_NumBranch,
          //       // BP_Name: inform_repair_items?.BPCustomer?.Cus_Name,
          //       Service_Call: inform_repair_items?.service_call,
          //       Project_No: inform_repair_items?.CustContract?.project_no
          //     })
          //   )
          // }));
          // setParent(
          //   newAdditionalValue.map(
          //     ({ inform_repair_items }) =>
          //       inform_repair_items?.informrepairitems
          //   )
          // );
        }
        break;

      default:
        {
          setData((prevData) => ({
            ...prevData,
            BillOfReqHd: {
              ...prevData.BillOfReqHd,
              ...{
                Job_Type_Id: newOther?.Job_Type_Id,
                Seq_Pm_Id: null,
                Seq_Inst_Id: null,
                Seq_Oth_Id: null,
                Seq_Serv_Id: newOther?.Seq_Id,
                Bill_Doc_No: null,
                Bill_Doc_Date: currentDate,
                Ref_Seq_No: newOther?.Seq_No,
                Job_Type_Name: newOther?.InformOtherJob?.JobType?.Job_Type_Name,
                Job_Type_Sub_Name:
                  newOther?.InformOtherJob?.JobTypeSub?.Job_Type_Sub_Name,
                Cus_Code: newOther?.InformOtherJob?.Customer?.Cus_Code || null,
                Cus_Name: newOther?.InformOtherJob?.Customer?.Cus_Name || null,
                BP_Code: newOther?.InformOtherJob?.BPCustomer?.Cus_Code || null,
                BP_NumBranch:
                  newOther?.InformOtherJob?.BPCustomer?.Cus_NumBranch || null,
                BP_Name: newOther?.InformOtherJob?.BPCustomer?.Cus_Name || null,
                Service_Call: newOther?.InformOtherJob?.Service_call || null,
                Project_No:
                  newOther?.InformOtherJob?.CustContract?.Project_no || null
              }
            }
          }));

          setItems(
            newOther?.InformOtherJob?.ItemOther.map((item) => item.Item)
          );
          setData((prev) => ({
            ...prev,
            BillOfReqDt: newOther?.InformOtherJob?.ItemOther.map((item) => item)
          }));
        }
        break;
    }
  };

  const handleSearchParent = (search) => {
    setParentSearch(search?.value);

    if (searchValue) {
      const serviceMap = {
        "001": InformInstallItemBomsService.getAllInformInstallItemBoms,
        "002": SeqRepairJobsService.getAllSeqRepairJob,
        "005": SeqPMJobsService.getAllSeqPMJobs
      };
      const serviceRequest = serviceMap[searchValue];
    }


    // setData((prev) => ({
    //   ...prev,
    //   BillOfReqDt: newOther?.InformOtherJob?.ItemOther.map((item) => item)
    // }));



  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal((prev) => ({ ...prev, save: true }));
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal((prev) => ({ ...prev, save: showCallback }));

    if (dataCallback) {
      const { BillOfReqHd, BillOfReqDt } = dataCallback;

      const newBillOfReqDt = BillOfReqDt.map((item) => ({
        Bill_Of_Hd_Id: item.Bill_Of_Hd_Id || null,
        Item_Id: item.Item_Id || null,
        Item_Child_Id: item.Item_Child_Id || null,
        Wh_Code: item.Wh_Code || null,
        Wh_Bal_Qty: item.Wh_Bal_Qty || null,
        Req_Qty: item.Item_Install_Qty || null,
        Iss_Qty: item.Iss_Qty || null,
        Bal_Iss_Qty: item.Bal_Iss_Qty || null,
        Unit_Uom: item.Unit_Uom || null,
        Use_Status: item.Use_Status || null,
        Com_Code: item.Com_Code || null
      }));

      onSubmitCallback(BillOfReqHd, newBillOfReqDt);
    }
  };

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: JobTypeService.getAllJobTypes(),
      callback: (res) =>
        isEditMode
          ? setJobType(res)
          : setJobType(
            res.filter(({ Job_Type_Code }) => {
              const result =
                state?.name === "create"
                  ? ["001", "002", "005"].includes(Job_Type_Code)
                  : !["001", "002", "005"].includes(Job_Type_Code);
              setCheckType(!result);
              return result;
            })
          )
    });

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: WarehouseService.getAllWarehouse(),
      callback: (items) => setWarehouse(items)
    });

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ChildBomsService.getAllChildBoms(),
      callback: (items) => setChildBoms(items)
    });

    if (state?.job_type_id) handleSearchType([{ value: '00' + state.job_type_id }])
  }, []);

  return (
    <>
      <CardDisplayComponent
        header={{
          title: {
            className: "text-center",
            text: isEditMode
              ? "เลือกประเภทงานและเลขที่ใบขอเบิก"
              : state?.name === "create"
                ? "เลือกประเภทงานและเลขที่ใบสั่งงาน"
                : "เลือกประเภทและเลขที่ใบสั่งงานขาย"
          }
        }}
        body={{
          element: (
            <>
              <Row>
                <Col sm={3}></Col>
                <Col sm={3}>
                  <SearchFilter
                    data={JobType || []}
                    inputField={searchType}
                    searchCallback={handleSearchType}
                  />
                </Col>
                <Col sm={3}>
                  <SearchSelectComponent
                    floatingClass="mb-1"
                    labelField="เลขที่ใบสั่งงาน"
                    placeholder="โปรดเลือก"
                    disabled={JopTypeId ? false : true}
                    filterBy={["Seq_No"]}
                    options={initializeSetOption({
                      key: "Seq_Id",
                      label: "Seq_No",
                      dataset: Seq
                    })}
                    onChange={handleSearchSeq}
                    value={CheckSeq}
                  />
                </Col>
                <Col sm={3}></Col>
              </Row>
            </>
          )
        }}
      />
      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <CardDisplayComponent
          body={{ element: InputSearch(inputField.Input) }}
        />

        <div>
          {state?.name !== "requisitions" && (
            <CardDisplayComponent
              header={{
                title: {
                  text: "เลือกสินค้าเพื่อกำหนดรายละเอียด",
                  className: "text-center"
                }
              }}
              body={{
                element: (
                  <Row className="justify-content-center">
                    <Col sm={3}>
                      <SearchSelectComponent
                        floatingClass="mb-1"
                        labelField="รหัสสินค้า"
                        placeholder="โปรดเลือก"
                        noneAsync={true}
                        filterBy={["Item_Code"]}
                        options={initializeSetOption({
                          key: "Id",
                          label: "Item_Code",
                          dataset: Parent
                        })}
                        onChange={handleSearchParent}
                        value={`${ParentSearch}`}
                      />
                    </Col>
                    {/* {console.log(Parent)} */}
                    <Col sm={6}>
                      <FloatingControlComponent
                        type="text"
                        name={"Item_Name_TH"}
                        label="รายละเอียดสินค้า"
                        readOnly
                        value={autoDisplayValue({
                          name: "Item_Name_TH",
                          type: "text",
                          findValue: {
                            data: Parent,
                            key: "Id",
                            value: ParentSearch
                          }
                        })}
                      />
                    </Col>
                  </Row>
                )
              }}
            />
          )}
        </div>

        <CardDisplayComponent
          header={{ title: { text: "แสดงรายละเอียดใบขอเบิก" } }}
          body={{
            element: (
              <>
                <TableForm
                  data={data?.BillOfReqDt || []}
                  columns={inputField?.BillOfReqDt}
                  defaultData={defaultData?.BillOfReqDt}
                  duplicateKey={["Item_Id"]}
                  passKey={["Iss_Qty", "Use_Status", "Com_Code"]}
                  onChangeCallback={(newData) => {
                    const findId = data.BillOfReqDt.find(
                      ({ Id }) => !newData.some((item) => Id === item.Id)
                    )?.Id;

                    if (isEditMode && findId) {
                      setShowModal((prev) => ({ ...prev, del: true }));
                      setFindDel({ Id: findId, newData });
                    } else {
                      setData((prev) => ({
                        ...prev,
                        BillOfReqDt: newData.map(
                          ({
                            Item_Install_Qty,
                            Iss_Qty,
                            Item_Id,
                            Unit_Uom,
                            Use_Status,
                            ...item
                          }) => {
                            const sumValue = !Item_Install_Qty
                              ? 0
                              : calculator({
                                num1: Item_Install_Qty,
                                num2: Iss_Qty,
                                operator: "-"
                              });
                            const fieldUnit = findItemInArray(
                              Items,
                              "Id",
                              Item_Id
                            );
                            return {
                              ...item,
                              Item_Id: Number(Item_Id),
                              Item_Install_Qty: Number(Item_Install_Qty),
                              Iss_Qty: Number(Iss_Qty),
                              Bal_Iss_Qty: sumValue,
                              Unit_Uom: fieldUnit?.Unit || Unit_Uom,
                              Use_Status: Use_Status
                            };
                          }
                        )
                      }));
                    }
                  }}
                />

                <ConfirmModal
                  show={showModal.del}
                  data={findDel}
                  content={isEditMode ? "edit" : "save"}
                  onSubmitCallback={(event, { dataCallback, showCallback }) => {
                    setShowModal((prev) => ({ ...prev, del: showCallback }));
                    if (dataCallback) {
                      const { Id, newData } = dataCallback;
                      deleteServiceRequest({
                        showAlert,
                        setLoading,
                        serviceRequest: BillOfReqDtService.deleteBillOfReqDts(
                          Id,
                          true
                        )
                      });

                      setData((prev) => ({
                        ...prev,
                        BillOfReqDt: newData.filter((nd) => nd?.Id !== Id)
                      }));
                    }
                  }}
                />
              </>
            )
          }}
        />

        <CardDisplayComponent
          body={{
            element: (
              <>
                <Row>
                  <Col sm={9}>
                    {InputSearch(
                      inputField.Input_2,
                      "justify-content-end align-items-end"
                    )}
                  </Col>
                  <Col sm={3} className="mt-2">
                    <Button
                      type="submit"
                      variant="success"
                      className="me-2 px-5 py-2 text-dark rounded-pill"
                    >
                      บันทึกข้อมูล
                    </Button>
                    <ConfirmModal
                      show={showModal.save}
                      data={data}
                      content={isEditMode ? "edit" : "save"}
                      onSubmitCallback={handleSubmit}
                    />
                  </Col>
                </Row>
              </>
            )
          }}
        />
      </Form>
    </>
  );
};

CreateRequisitionForm.propTypes = { onSubmitCallback: PropTypes.func };

export default CreateRequisitionForm;
